<template>
  <div class="assist-wrapper">
    <header-box/>
    <router-view />
    <Footer/>
  </div>
</template>

<script type="text/ecmascript-6">
const headerBox = () => import('@/components/assist/head')
const Footer = () => import('@/components/footer')
export default {
  components: {
    headerBox,
    Footer
  },
  data() {
    return {
      bgColor: ''
    }
  },
  watch: {
    $route(v) {
      this.bgColor = v.meta['bgColor'] || ''
    }
  },
  created() {
    this.$store.dispatch('getDictionary')
    this.$store.dispatch('getRegion')
    this.bgColor = this.$route.meta['bgColor'] || ''
  }
}
</script>
<style type="text/scss" lang="scss" scoped>
.assist-wrapper {
  .assist-header {
    .header-content {
      width: 1200px;
      margin: 0 auto;
      height: 100px;
      position: relative;
    }
  }
  .header-left {
    padding-top: 24px;

    a {
      display: inline-block;
      vertical-align: bottom;
    }

    img {
      display: block;
      margin-right: 25px;
    }

    span {
      color: #333;
      font-size: 16px;
      display: inline-block;
      vertical-align: bottom;
      padding-left: 20px;
      line-height: 24px;
      position: relative;

      &:before {
        content: "";
        position: absolute;
        left: 0;
        height: 15px;
        background: #aaa;
        width: 2px;
        top: 4px;
      }
    }
  }

  .header-right {
    position: absolute;
    right: 0;
    top: 37px;

    .el-button {
      margin-right: 10px;
    }

    span {
      padding-left: 12px;
      white-space: nowrap;
      color: #666;
      border-left: 1px solid #ccc;
      font-weight: bold;
    }
  }

  .assist-footer {
    width: 1200px;
    margin: 0 auto;
    text-align: center;
    padding: 20px 0 10px;

    p {
      font-size: 14px;
      color: #666;
      line-height: 24px;
      margin-bottom: 5px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/assist/index.vue